import { Component, inject, input, output } from "@angular/core";
import { DateInputModel } from "@app/filter-menu/filter-types";
import { WkDateFormat } from "../date-format";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { JumpstartComponentsModule as JumpstartComponentsModule_v3 } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-fm-due-on",
    standalone: true,
    templateUrl: "./due-on-dates.component.html",
    styleUrl: "./due-on-dates.component.scss",
    imports: [JumpstartComponentsModule_v3, TranslateModule],
})
export class DueOnDatesComponent {
    protected readonly WkDateFormat = WkDateFormat;
    private readonly translateService = inject(TranslateService);

    model = input.required<DateInputModel>();

    dateChange = output<string>();

    currentLanguage = "en-CA";

    constructor() {
        this.currentLanguage = this.translateService.getCurrentLang()
            ? this.translateService.getCurrentLang()
            : this.translateService.getFallbackLang();
    }
}
